import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getCustomFormQuestion, selectLabelItems, setLabelItems } from "slices";

import ShowQuestion from "./ShowQuestion";

const CustomFormQuestion = ({ setQuestionDisabled, customQuestions, setCustomQuestions }) => {
  const prevLabel = useSelector(selectLabelItems);
  const customFormQuestion = useSelector(getCustomFormQuestion);

  const dispatch = useDispatch();

  const labelObj = { ...prevLabel };

  useEffect(() => {
    const isRequiredFieldsFilled = Object.keys(customFormQuestion || {})
      .filter((key) => customFormQuestion[key].isRequired)
      .every((key) => {
        const formQuestion = customFormQuestion[key];
        const customAnswer = customQuestions[key]?.answer;

        return formQuestion.isRequired && customAnswer !== undefined && customAnswer !== null && customAnswer !== "";
      });

    setQuestionDisabled(!isRequiredFieldsFilled);

    if (isRequiredFieldsFilled && Object.keys(customQuestions || {}).length) {
      labelObj.custom_questions = JSON.stringify(customQuestions);
      dispatch(setLabelItems(labelObj));
    }
  }, [customFormQuestion, customQuestions]);

  return customFormQuestion ? (
    <div className="hayley-mt-3 hayley-w-full hayley-space-y-3">
      {Object.keys(customFormQuestion || {}).map((v, i) => (
        <ShowQuestion question={customFormQuestion[v]} objKey={v} key={i} customQuestions={customQuestions} setCustomQuestions={setCustomQuestions} />
      ))}
    </div>
  ) : null;
};

export default CustomFormQuestion;
